import React from 'react';
import { Link } from 'react-router-dom';
import { ROUTES } from '../../constants';
import './manualPurchase.css';

const PurchaseHeader = ({ create = false, action }) => (
  <header className='purchase-card bg-white px-5 py-5'>
    <nav aria-label='Breadcrumb' className='mb-[18px] text-sm text-[#96989b]'>
      <ol className='flex flex-wrap items-center gap-x-[10px] gap-y-1'>
        <li>
          <Link to={ROUTES.DASHBOARD}>Dashboard</Link>
        </li>
        <li aria-hidden='true'>/</li>
        <li>
          {create ? (
            <Link to={ROUTES.PURCHASES}>Purchases</Link>
          ) : (
            <span aria-current='page' className='text-slate-700'>
              Purchases
            </span>
          )}
        </li>
        {create && (
          <>
            <li aria-hidden='true'>/</li>
            <li aria-current='page' className='text-slate-700'>
              Create Purchases
            </li>
          </>
        )}
      </ol>
    </nav>
    <div className='flex flex-wrap items-end justify-between gap-4'>
      <div>
        <h1 className='text-2xl sm:text-[30px] leading-[37px] font-semibold'>
          {create ? 'Create Purchases' : 'Purchases'}
        </h1>
        {!create && (
          <p className='mt-[3px] text-base text-[#646676]'>
            Create an event ticket purchase after Management approves the final
            amount.
          </p>
        )}
      </div>
      {action}
    </div>
  </header>
);
export default PurchaseHeader;
